import React, { useState, useRef, useEffect } from "react";
import PostPDF from "../../../services/PostPdf.js";
import { Dialog } from "@mui/material"
import InvoiceResponse from "../InvoiceResponse.jsx"
import SnackbarEx from "../../Helpers/SnackbarEx.jsx";
import DisplayPdf from "../DisplayPdf.jsx"
import SupplierConfirmDialog from "../SupplierConfirmDialog.jsx";

export default function SingleFile() {
    const [pdfFile, setPdfFile] = useState(null)
    const [load, setLoad] = useState(false)
    const [isDragging, setIsDragging] = useState(false)
    const [openResponseDialog, setOpenResponseDialog] = useState(false)
    const [responseData, setResponseData] = useState(null)
    const [processingDots, setProcessingDots] = useState(0);
    const [detectOpen, setDetectOpen] = useState(false)
    const [detectLoading, setDetectLoading] = useState(false)
    const [detection, setDetection] = useState(null)

    const [openTestSnack, setOpenTestSnack] = useState({
        color: "",
        message: "",
        open: false
    })

    useEffect(() => {
        let intervalId;
        if (load) {
            intervalId = setInterval(() => {
                setProcessingDots(prevDots => (prevDots % 4) + 1);
            }, 500);
        } else {
            setProcessingDots(0);
        }
        return () => clearInterval(intervalId);
    }, [load]);

    const handleFile = ({ target }) => {
        setPdfFile(target.files[0])
    }

    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = e.dataTransfer.files;
        if (droppedFiles.length > 0) {
            setPdfFile(Array.from(droppedFiles)[0])
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        setIsDragging(false);
    };

    const fileInputRef = useRef(null);
    const handleBrowseClick = () => {
        fileInputRef.current.click();
    };

    /** Step 1: detect supplier (no Gemini) */
    const handleUpload = async (e) => {
        e.preventDefault()
        if (!pdfFile) return
        setDetectLoading(true)
        setDetectOpen(true)
        try {
            const formData = new FormData()
            formData.append("file", pdfFile, pdfFile.name)
            const { data, error } = await PostPDF(formData, "broylesllc/detect-invoice-supplier")
            if (error || !data) {
                setDetectOpen(false)
                setOpenTestSnack({ color: "error", message: "Could not detect supplier.", open: true })
                return
            }
            setDetection(data)
        } catch (err) {
            console.log(err)
            setDetectOpen(false)
            setOpenTestSnack({ color: "error", message: "Could not detect supplier.", open: true })
        } finally {
            setDetectLoading(false)
        }
    }

    /** Step 2: user confirmed → Gemini OCR with config schema */
    const handleConfirmSupplier = async (config) => {
        setDetectOpen(false)
        setLoad(true)
        try {
            const formData = new FormData()
            formData.append("file", pdfFile, pdfFile.name)
            formData.append("configId", config._id)

            const { data: PDFSuccess, error: PDFError } = await PostPDF(formData, "broylesllc/post-pdf-invoice")
            if (PDFError || !PDFSuccess) {
                setOpenTestSnack({ color: "error", message: "OCR failed. Try again.", open: true })
                return
            }
            setResponseData({
                pdf: PDFSuccess,
                type: "single",
                invoiceCount: 0,
                importConfig: config,
            })
            setOpenResponseDialog(true)
        } catch (err) {
            console.log(err)
            setOpenTestSnack({ color: "error", message: "OCR failed. Try again.", open: true })
        } finally {
            setLoad(false)
        }
    }

    const handleClose = (val) => {
        setOpenResponseDialog(false)
        if (val === "Success") {
            setPdfFile(null)
            setOpenTestSnack({ color: "success", message: "Invoice added successfully! Check Invoices to see it.", open: true })
        } else if (val === "Exists") {
            setPdfFile(null)
            setOpenTestSnack({ color: "warning", message: "Invoice already exists in Invoices.", open: true })
        }
    }

    const renderDots = () => ".".repeat(processingDots);

    return (
        <div style={{ padding: '0 1%', display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '10px' }}>
            <div className='row' style={{
                transition: 'border-color 0.2s, background-color 0.2s',
                borderStyle: 'dashed', width: '100%'
            }}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
            >
                <img
                    src="uploadIcon.svg"
                    alt="Upload Icon"
                    className="d-block mx-auto mb-3 text-secondary"
                    style={{ width: '4rem', height: '4rem' }}
                />
                <p>
                    <span>Drop your files here,</span> or{' '}
                    <button
                        onClick={handleBrowseClick}
                        className="btn btn-link p-0 fw-medium"
                    >
                        click to browse
                    </button>
                </p>
                <input
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFile}
                    accept="application/pdf"
                    style={{ display: 'none' }}
                />
            </div>
            <div style={{ height: '100px' }}>
                {pdfFile &&
                    <div className='row' style={{ marginTop: '15px' }}>
                        <p style={{ margin: '0 0 0 10px' }}>File:<em> {pdfFile.name}</em></p>
                    </div>
                }
            </div>
            <div style={{ marginTop: '20px', width: '90%' }}>
                <button
                    disabled={!pdfFile || load}
                    className={'submit'}
                    style={{ width: "100%", margin: '0', cursor: "pointer", display: 'flex', justifyContent: 'center', alignItems: 'center ' }}
                    onClick={handleUpload}>
                    {load ? <span> Processing{renderDots()}</span> : "Upload Files"}
                </button>
            </div>

            <SupplierConfirmDialog
                open={detectOpen}
                detection={detection}
                loading={detectLoading}
                onCancel={() => { setDetectOpen(false); setDetection(null); }}
                onConfirm={handleConfirmSupplier}
            />

            <Dialog maxWidth={'lg'} fullWidth open={openResponseDialog} onClose={(val) => handleClose(val)}>
                <div style={{ display: 'flex' }}>
                    <div style={{ width: '50%' }}>
                        <DisplayPdf pdfFile={pdfFile} />
                    </div>
                    <div style={{ width: '50%', borderLeft: 'solid' }}>
                        <InvoiceResponse responseData={responseData} closeDialog={(val) => handleClose(val)} />
                    </div>
                </div>
            </Dialog>

            {openTestSnack.open && <SnackbarEx color={openTestSnack.color} message={openTestSnack.message} open={openTestSnack.open}
                close={() => setOpenTestSnack({ color: "", message: "", open: false })} />}
        </div>
    )
}
